__turbopack_context__.v({
  "newOrderCard": "OutletsListPageSkeleton-module-scss-module__CeaI8W__newOrderCard",
  "rightContainer": "OutletsListPageSkeleton-module-scss-module__CeaI8W__rightContainer",
  "skeletonContainer": "OutletsListPageSkeleton-module-scss-module__CeaI8W__skeletonContainer",
  "wrapper": "OutletsListPageSkeleton-module-scss-module__CeaI8W__wrapper",
});
